export default {
  nav: {
    categories: 'Categorieën',
    topSites: 'Topwebsites',
    compare: 'Vergelijken',
    submitSite: 'Site toevoegen',
    about: 'Over',
    logIn: 'Inloggen',
  },
  common: {
    back: 'Terug',
    search: 'Zoeken',
    loading: 'Bezig met laden…',
    viewSimilarSites: 'Bekijk vergelijkbare sites',
  },
  hero: {
    badge: 'Site-ontdekkingsmachine',
    titleA: 'Vind websites vergelijkbaar met',
    titleB: 'je favorieten.',
    titlePrefix: 'Vind websites vergelijkbaar met',
    titleAccent: 'je favorieten.',
    subtitle: 'Ontdek concurrenten, alternatieven en verborgen parels op het web met nauwkeurige similariteitsscores.',
    placeholder: 'Voer een domein in (bijv. stripe.com)',
    inputPlaceholder: 'Voer een domein in (bijv. stripe.com)',
    step1Label: 'Voer een domein in',
    step1Desc: 'Typ een website-URL om te starten',
    step2Label: 'Krijg matches',
    step2Desc: 'Onze engine vindt direct vergelijkbare sites',
    step3Label: 'Vergelijk & kies',
    step3Desc: 'Analyseer en vergelijk alternatieven',
    steps: {
      step1Label: 'Voer een domein in',
      step1Desc: 'Typ een website-URL om te starten',
      step2Label: 'Krijg matches',
      step2Desc: 'Onze engine vindt direct vergelijkbare sites',
      step3Label: 'Vergelijk & kies',
      step3Desc: 'Analyseer en vergelijk alternatieven',
    },
  },
  footer: {
    newsletterTitle: 'Blijf op de hoogte',
    newsletterDesc: 'Ontvang wekelijkse updates over trending sites en nieuwe alternatieven.',
    emailPlaceholder: 'jij@email.nl',
    subscribe: 'Abonneren',
    brandDesc: 'Ontdek de verborgen verbindingen van het web. Vind vergelijkbare websites met nauwkeurige scoring.',
    explore: 'Ontdekken',
    popular: 'Populair',
    company: 'Bedrijf',
    compareSites: 'Sites vergelijken',
    sitesLike: 'Sites zoals',
    contact: 'Contact',
    faq: 'FAQ',
    removeYourSite: 'Verwijder je site',
    privacyPolicy: 'Privacybeleid',
    termsOfService: 'Servicevoorwaarden',
    rights: 'Alle rechten voorbehouden.',
  },
  notFound: {
    title: 'Oeps! Pagina niet gevonden',
    returnHome: 'Terug naar home',
  },
  submitPage: {
    ctaTitle: 'Ken je een geweldige website?',
    ctaDesc: 'Help onze database groeien door sites die je leuk vindt in te sturen. Het duurt maar een paar seconden.',
    ctaButton: 'Site toevoegen',
    pageTitle: 'Site toevoegen',
    pageSubtitle: 'Help ons groeien door een website in te sturen voor indexering.',
    successTitle: 'Site ingediend!',
    successReviewPrefix: 'We beoordelen',
    successReviewSuffix: 'en voegen de site binnenkort toe aan onze index.',
    backHome: 'Terug naar home',
    domainLabel: 'Domein *',
    domainPlaceholder: 'bijv. example.com',
    descriptionLabel: 'Beschrijving',
    descriptionPlaceholder: 'Korte beschrijving van de site',
    categoryLabel: 'Categorie',
    categorySelect: 'Kies een categorie',
    alternativeTo: 'Alternatief voor (optioneel)',
    alternativeNone: 'Geen — geen alternatief',
    emailLabel: 'Je e-mail',
    emailPlaceholder: 'jij@voorbeeld.nl',
    submitButton: 'Site versturen',
    submitFailed: 'Versturen mislukt',
    seoTitle: 'Site toevoegen | CiteMatch',
    seoDesc: 'Dien een website in voor indexering op CiteMatch.',
  },
};

